import { useCurrentRefinements } from "react-instantsearch";

const CustomRefinementTitle = (props) => {
  //  returns all the items which are selected.
  const { items } = useCurrentRefinements(props);
  var multipleValues = false;
  return (
    <>
      {items.map((singleLevelFilters) => {
        if (singleLevelFilters.refinements.length > 1) {
          multipleValues = true;
        }
        var lastEle = singleLevelFilters.refinements[singleLevelFilters.refinements.length - 1];
        return singleLevelFilters.refinements.map((refinement, index) => {
          if (refinement === lastEle) {
            multipleValues = false;
          }
          const levelLabelsArray = refinement.label.split(">");
          var addComma = multipleValues ? "," : "";
          const actualLabel = levelLabelsArray[levelLabelsArray.length - 1] + addComma;
          return (
              refinement.attribute === props.attribute && actualLabel
          );
        });
      })}
    </>
  );
};

export default CustomRefinementTitle;